"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAgent = exports.verifyRate = exports.verifyTariff = exports.verifyTariffGroup = exports.verifyFlightListItem = void 0;
const verifyFlightListItem = (value) => {
    if (!value)
        return undefined;
    if (!value.origin) {
        console.error('ObjectId value does not have data type FlightListItem');
        return undefined;
    }
    return value;
};
exports.verifyFlightListItem = verifyFlightListItem;
const verifyTariffGroup = (value) => {
    if (!value)
        return undefined;
    if (!value.name) {
        console.error('ObjectId value does not have data type TariffGroup');
        return undefined;
    }
    return value;
};
exports.verifyTariffGroup = verifyTariffGroup;
const verifyTariff = (value) => {
    if (!value)
        return undefined;
    if (!value.group) {
        console.error('ObjectId value does not have data type Tariff');
        return undefined;
    }
    return value;
};
exports.verifyTariff = verifyTariff;
const verifyRate = (value) => {
    if (!value)
        return undefined;
    if (!value.name) {
        console.error('ObjectId value does not have data type Rate');
        return undefined;
    }
    return value;
};
exports.verifyRate = verifyRate;
const verifyAgent = (value) => {
    if (!value)
        return undefined;
    if (!value.email) {
        console.error('ObjectId value does not have data type Agent');
        return undefined;
    }
    return value;
};
exports.verifyAgent = verifyAgent;
//# sourceMappingURL=verify.js.map